<script setup lang="ts">
import { onMounted, ref, watchEffect } from "vue";
import { RouterView } from "vue-router";
import { useRouter } from "vue-router";
import { provideGcsAppCore } from "./appCore";
import AppLoadingScreen from "./components/loading/AppLoadingScreen.vue";
import { messages, type Locale } from "./i18n";
import { BaseButton } from "@lunagoai/vue-ui";

const appCore = provideGcsAppCore();
const router = useRouter();
const appBoot = ref<"loading" | "ready" | "failed">("loading");

onMounted(() => {
  document.getElementById("gcs-html-loader")?.remove();
  void router.isReady().then(() => {
    appBoot.value = "ready";
  }).catch(() => {
    appBoot.value = "failed";
  });
});

function reloadApp(): void {
  window.location.reload();
}

watchEffect(() => {
  const locale = appCore.language.currentLanguage.value as Locale;
  document.documentElement.lang = locale === "zh-TW" ? "zh-Hant" : "en";
  document.title = messages[locale].title;
  document.documentElement.style.colorScheme = appCore.theme.isDark.value ? "dark" : "light";
});
</script>

<template>
  <AppLoadingScreen v-if="appBoot === 'loading'" label="正在啟動輿情分析系統…" />
  <div v-else-if="appBoot === 'failed'" class="grid min-h-screen place-items-center bg-slate-950 px-6 text-center text-slate-100">
    <div><p class="text-lg font-semibold">應用程式載入失敗</p><p class="mt-2 text-sm text-slate-400">請重新整理頁面再試一次。</p><BaseButton class="mt-5" variant="primary" label="重新整理" @click="reloadApp" /></div>
  </div>
  <RouterView v-else />
</template>
